import { IconProps } from "./types";

export const SpriteIcon = ({ name, className, section, ...props }: IconProps) => {
    return (
        <svg className={className} aria-hidden="true" focusable="false" {...props}>
            <use xlinkHref={`/sprites/${section}.svg#${name}`} />
        </svg>
    );
};